import { makeStyles } from "../Utilities/ThemeHelper";
import classNames from "classnames";
import React, { useCallback } from "react";
import MenuItem from "../MenuItem";
import Checkbox from "../Checkbox";
import Divider from "../Divider";
const useStyles = makeStyles(theme => {
  const focusedStyles = {
    background: theme.palette.grey[300],
    color: theme.palette.getContrastText(theme.palette.grey[300])
  };
  const selectedStyles = {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  };
  return {
    icon: {
      marginRight: theme.spacing(1),
      display: "inline-flex"
    },
    root: {
      padding: theme.spacing(2),
      background: theme.palette.background.paper,
      color: theme.palette.text.primary,
      cursor: "pointer",
      transition: theme.transitions.create(["background", "color"], {
        duration: theme.transitions.duration.shortest
      }),
      "&:hover": focusedStyles,
      ".prmbl-autocomplete__menu-list:hover &.isFocused": {
        // When showing the hover, disable the background on the keyboard-focused item
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        // Re-enable it if hovering the keyboard-focused item
        "&:hover": focusedStyles
      }
    },
    selectAll: {
      height: theme.spacing(7)
    },
    compactItem: {
      padding: theme.spacing(1)
    },
    focused: focusedStyles,
    selected: {
      "&.prmbl-menuItem": {
        ...selectedStyles,
        // Disable the hover style for the selected item
        "&:hover": selectedStyles
      },
      ".prmbl-autocomplete__menu-list:hover &.isFocused": {
        ...selectedStyles,
        // Disable the hover style for the selected item
        "&:hover": selectedStyles
      }
    },
    checkbox: {
      marginRight: theme.spacing(1)
    },
    divider: {
      background: theme.palette.grey["500"]
    }
  };
});
export const Option = props => {
  const {
    id,
    className,
    children,
    isSelected,
    isFocused,
    data,
    options,
    label,
    selectProps,
    selectOption
  } = props;
  const classes = useStyles(props);
  const isSelectAll = label === "Select All";
  const allSelected = selectProps?.value ? Object.values(selectProps?.value).length : 0;
  const groupOption = options?.flatMap(option => option["options"]).filter(value => value !== undefined);
  const allOptions = groupOption && groupOption?.length > 0 ? groupOption.length : options && options?.length - 1;
  const isAllSelected = isSelectAll && allOptions && allSelected === allOptions;
  const isIndeterminate = allSelected > 0 && isSelectAll && !isAllSelected;
  const isMulti = props.selectProps?.isMulti;
  const isCompact = props.selectProps?.classNamePrefix?.includes("prmbl-autocomplete-compact");
  const icon = data && data.icon;
  const handleClick = useCallback(event => {
    let selectedOption;
    options?.forEach(option => {
      if ("options" in option) {
        // This is a group of options, check each item in the group
        option.options.forEach(groupOption => {
          if (groupOption.label === label) {
            selectedOption = groupOption;
            return;
          }
        });
        // If we found the item in the group, quit looking
        if (selectedOption !== undefined) return;
      } else {
        if (option.label === label) {
          // We found the item
          selectedOption = option;
          return;
        }
      }
    });
    if (selectedOption && selectOption) {
      selectOption(selectedOption, event);
    }
  }, [label, options, selectOption]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, {
    className: classNames(classes.root, className, "prmbl-autocomplete__option", {
      [classes.selected]: !isMulti && isSelected,
      // Only show the selected style for single-select
      [classes.focused]: isFocused,
      [classes.compactItem]: isCompact,
      [classes.selectAll]: isSelectAll && !isCompact,
      isFocused: isFocused
    }),
    id: id ? `${id}-menu-item` : undefined,
    selected: isAllSelected || isSelected,
    onClick: handleClick,
    component: "li",
    dense: isCompact
  }, isMulti && /*#__PURE__*/React.createElement(Checkbox, {
    className: classes.checkbox,
    id: `${id}-label`,
    checked: isAllSelected || isSelected,
    indeterminate: isIndeterminate,
    size: isCompact ? "small" : undefined
  }), icon ? /*#__PURE__*/React.createElement("span", {
    className: classNames(classes.icon, "prmbl-autocomplete__option-icon")
  }, icon) : null, children), isSelectAll && /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }));
};
export default Option;